module.exports = __webpack_public_path__ + "static/media/homeVideo.4f3cd7c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/homeVideo.mp4
// module id = Hpau
// module chunks = 283